// extracted by mini-css-extract-plugin
module.exports = {"applicationTypeRadioGroup":"BorrowerForm_applicationTypeRadioGroup__2q4LU","rowVerticalSpacing":"BorrowerForm_rowVerticalSpacing__3DEXw"};